<template>
    <div v-for="daySale in formData.daySales" :key="daySale.productType">
        <div class="text-subtitle-1 font-weight-medium">
            {{ $t('sales_conditions_for') }}
            {{ `'${$t(`productType.${daySale.productType}`)}'` }}
        </div>
        <div class="pb-3">
            <div class="d-flex align-center flex-wrap gc-3">
                {{ $t('available_for_sale') }}
                <v-number-input
                    v-model="daySale.period"
                    :min="0"
                    :max="120"
                    hide-details
                    max-width="100"
                    density="compact"
                />
                {{ $t('day_before_service_start_date') }}
            </div>
            <v-checkbox
                v-if="daySale.productType === 'accommodation'"
                v-model="formData.showPackageRates"
                :label="$t('show_package_rates')"
                data-cy="show-package-rates"
            />
        </div>
    </div>
    <div class="text-subtitle-1 pb-3">{{ $t('print_vouchers') }}</div>
    <v-radio-group v-model="formData.voucherMode">
        <v-radio v-for="{value, title} in useVoucherMode" :key="value" :label="title" :value="value" :data-cy="value" />
    </v-radio-group>
    <div v-if="contractGroupPlace !== 'B2C'" class="pb-4">
        <div class="text-subtitle-1 pb-3">{{ $t('activate_sales_mode') }}</div>
        <v-checkbox v-model="formData.b2bPointOfSale" label="B2B" data-cy="b2b-point-of-sale" hide-details />
        <v-checkbox v-if="!isTAContract" v-model="formData.b2cPointOfSale" label="B2C" data-cy="b2c-point-of-sale" />
    </div>
    <template v-if="contractGroupPlace !== 'B2C' && runtimeStore.getCRMOption('asp.option.credit.limit.settings')">
        <div class="text-subtitle-1 pb-3">{{ $t('credit_limit') }}</div>
        <div
            v-for="creditLimit in formData.creditLimitSettings"
            :key="creditLimit.creditLimitType"
            class="d-sm-table-row"
        >
            <div class="d-sm-table-cell align-middle pr-4 mb-4 mb-sm-0">
                <v-checkbox
                    v-model="creditLimit.creditLimitExceeded"
                    :label="$t(`creditLimitSettings.${creditLimit.creditLimitType}`)"
                    :data-cy="creditLimit.creditLimitType"
                    hide-details
                    class="checkbox-label"
                />
            </div>
            <div class="d-sm-table-cell align-middle mb-4 mb-sm-0">
                <div class="d-flex align-center ga-2 mb-sm-2">
                    <v-number-input
                        v-model="creditLimit.creditLimitValue"
                        :min="0"
                        hide-details
                        :data-cy="`value-for-${creditLimit.creditLimitType}`"
                        density="compact"
                        width="250"
                        max-width="250"
                    />
                    <span>{{ authStore.systemCurrency }}</span>
                </div>
            </div>
        </div>
    </template>
    <!--TODO[p0] add Payment Plan - after implementation in api -->
</template>
<script setup lang="ts">
    const formData = defineModel<any>()
    const isTAContract: boolean = inject('isTAContract', false)
    const contractGroupPlace = inject('contractGroupPlace')

    const {t} = useI18n()

    const useVoucherMode = computed(() => {
        return [
            {value: 'PERMIT', title: t('voucherMode.PERMIT')},
            {value: 'PERMIT_AFTER_PAYMENT', title: t('voucherMode.PERMIT_AFTER_PAYMENT')},
            {value: 'PERMIT_AFTER_UNSET_AUTOCANCEL', title: t('voucherMode.PERMIT_AFTER_UNSET_AUTOCANCEL')},
            {value: 'PREVENT', title: t('voucherMode.PREVENT')},
        ]
    })
</script>
